import {
  AddIcon,
  ButtonLink,
  Popup,
  PopupContent,
  PopupFooter,
  PopupHeader,
  PopupProps,
  Tab,
  Tabs,
  Theme,
  useMediaQuery,
  useTheme,
} from '@freighthub/silhouette-core'
import { ChangeEvent, FC, useState } from 'react'
import { useI18n } from 'utils/localisation'

import { BookingTemplatesList } from './BookingTemplatesList'
import { RecentQuotesList } from './RecentQuotesList'

enum TabId {
  RecentQuotes,
  BookingTemplates,
}

interface NewQuotePopupProps extends Pick<PopupProps, 'open' | 'anchorEl'> {
  onClose: () => void
}

export const NewQuotePopup: FC<NewQuotePopupProps> = ({ open, anchorEl, onClose, ...props }) => {
  const theme = useTheme<Theme>()
  const isTinyScreen = useMediaQuery(theme.breakpoints.down('xs'))
  const { translate } = useI18n()
  const [activeTabId, setActiveTabId] = useState<TabId>(TabId.RecentQuotes)

  const isBookingTemplatesActive = activeTabId === TabId.BookingTemplates

  const handleChangeTab = (_event: ChangeEvent, tabId: TabId): void => {
    setActiveTabId(tabId)
  }

  return (
    <Popup
      open={open}
      anchorEl={anchorEl}
      onClickAway={onClose}
      width={isTinyScreen ? `calc(100vw - ${theme.spacing(1)}px)` : 600}
      height={isBookingTemplatesActive ? 360 : 320}
      placement="bottom-start"
      {...props}
    >
      <PopupHeader paddingRight={0}>
        {/* @ts-expect-error TS(2322) FIXME: Type '(_event: ChangeEvent, tabId: TabId) => void'... Remove this comment to see the full error message */}
        <Tabs value={activeTabId} onChange={handleChangeTab}>
          <Tab
            value={TabId.RecentQuotes}
            label={translate('sidebar-new_quote-recent_quotes')}
            data-userlane-id="new-quote-popup-recent-quotes-tab"
          />
          <Tab
            value={TabId.BookingTemplates}
            label={translate('sidebar-new_quote-booking_templates')}
            data-userlane-id="new-quote-popup-booking-templates-tab"
          />
        </Tabs>
        {isBookingTemplatesActive && !isTinyScreen && (
          <ButtonLink
            to="/booking-templates/create"
            startIcon={<AddIcon />}
            onClick={onClose}
            data-userlane-id="button-booking-templates-popup-create"
          >
            {translate('recent_booking_templates-create_template')}
          </ButtonLink>
        )}
      </PopupHeader>
      <PopupContent>
        {activeTabId === TabId.RecentQuotes && <RecentQuotesList onClickItem={onClose} />}
        {activeTabId === TabId.BookingTemplates && <BookingTemplatesList onClickItem={onClose} />}
      </PopupContent>
      {isBookingTemplatesActive && (
        <PopupFooter alignItems="stretch">
          <ButtonLink
            to="/booking-templates"
            onClick={onClose}
            data-userlane-id="button-new-quote-more-view-templates"
            fullWidth
          >
            {translate('booking-template_view_all')}
          </ButtonLink>
        </PopupFooter>
      )}
    </Popup>
  )
}
